export const isBrowser = () => {
  return typeof window !== 'undefined';
};

export default isBrowser;
